import * as e from "react";
import { useState as A, useEffect as Z, useRef as J, useCallback as _e, Fragment as ct } from "react";
import { p as Qe, o as lt, h as it, d as dt } from "./format-CVedM0M8.js";
import { A as Xl, a as Cl, b as Sl, c as Fl, e as Bl, f as jl, g as Ll, i as Il, j as Dl, k as Ml, l as Tl, m as Rl, n as Pl, s as Ol, t as ql } from "./format-CVedM0M8.js";
import { c2 as Ye } from "./OBTResizeContainer-BGlq0udh.js";
import { A as zl, a as Wl, b as Kl, c as Hl, d as Vl, e as Ul, C as Ql, f as Yl, g as Jl, h as Zl, i as ei, j as ti, k as ai, l as ni, m as oi, n as si, o as ri, p as ci, q as li, r as ii, s as di, t as _i, u as mi, v as ui, w as pi, x as Ei, y as bi, z as fi, B as yi, D as gi, E as hi, F as vi, G as ki, H as Ni, I as Ai, J as wi, K as $i, L as xi, M as Xi, N as Ci, O as Si, P as Fi, Q as Bi, R as ji, S as Li, T as Ii, U as Di, V as Mi, W as Ti, X as Ri, Y as Pi, Z as Oi, _ as qi, $ as Gi, a0 as zi, a1 as Wi, a2 as Ki, a3 as Hi, a4 as Vi, a5 as Ui, a6 as Qi, a7 as Yi, a8 as Ji, a9 as Zi, aa as ed, ab as td, ac as ad, ad as nd, ae as od, af as sd, ag as rd, ah as cd, ai as ld, aj as id, ak as dd, al as _d, am as md, an as ud, ao as pd, ap as Ed, aq as bd, ar as fd, as as yd, at as gd, au as hd, av as vd, aw as kd, ax as Nd, ay as Ad, az as wd, aA as $d, aB as xd, aC as Xd, aD as Cd, aE as Sd, aF as Fd, aG as Bd, aH as jd, aI as Ld, aJ as Id, aK as Dd, aL as Md, aM as Td, aN as Rd, aO as Pd, aP as Od, c3 as qd, aQ as Gd, aR as zd, aS as Wd, aT as Kd, aU as Hd, aV as Vd, aW as Ud, aX as Qd, aY as Yd, aZ as Jd, a_ as Zd, a$ as e_, b0 as t_, b1 as a_, b2 as n_, b3 as o_, b4 as s_, b5 as r_, b6 as c_, b7 as l_, b8 as i_, b9 as d_, ba as __, bb as m_, bc as u_, bd as p_, be as E_, bf as b_, bg as f_, bh as y_, bi as g_, bj as h_, bk as v_, bl as k_, bm as N_, bn as A_, bo as w_, bp as $_, bq as x_, br as X_, bs as C_, bt as S_, bu as F_, bv as B_, bw as j_, bx as L_, by as I_, bz as D_, bA as M_, bB as T_, bC as R_, bD as P_, bE as O_, bF as q_, bG as G_, bH as z_, bI as W_, bJ as K_, bK as H_, bL as V_, bM as U_, bN as Q_, bO as Y_, bP as J_, bQ as Z_, bR as em, bS as tm, bT as am, bU as nm, bV as om, bW as sm, bX as rm, bY as cm, bZ as lm, b_ as im, b$ as dm, c0 as _m, c1 as mm } from "./OBTResizeContainer-BGlq0udh.js";
const Tc = {
  primary: "#1d4ed8",
  primaryBg: "#dbeafe",
  headerBg: "#1f2937",
  text: "#374151",
  textMuted: "#6b7280",
  border: "#e5e7eb",
  surface: "#f3f4f6"
}, je = "poc_portal_token", ge = "poc_portal_refresh", Ce = "auth:session-expired", Le = window.location.hostname === "dev.gennolab.co.jp" ? "" : "https://dev.gennolab.co.jp";
let Je = Le + "/chat-api/api/auth";
function Rc(t) {
  t.authBase && (Je = t.authBase);
}
function $e(t) {
  try {
    const a = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(decodeURIComponent(escape(atob(a))));
  } catch {
    return {};
  }
}
function _t(t, a = 30) {
  const n = $e(t).exp;
  return !n || n * 1e3 < Date.now() + a * 1e3;
}
function Ze(t = 30) {
  const a = localStorage.getItem(ge);
  if (!a) return !0;
  const n = $e(a).exp;
  return !!n && n * 1e3 < Date.now() + t * 1e3;
}
function et() {
  return localStorage.getItem(je);
}
function mt(t, a) {
  localStorage.setItem(je, t), a && localStorage.setItem(ge, a);
}
function ut() {
  localStorage.removeItem(je), localStorage.removeItem(ge), tt();
}
function fe() {
  ut(), window.dispatchEvent(new Event(Ce));
}
function Pc(t) {
  return window.addEventListener(Ce, t), () => window.removeEventListener(Ce, t);
}
let ye = null;
const pt = 2147483647;
function Et() {
  if (tt(), Ze()) {
    fe();
    return;
  }
  const t = localStorage.getItem(ge), a = t ? $e(t).exp : void 0;
  if (!a) return;
  const n = Math.min(Math.max(a * 1e3 - Date.now() - 30 * 1e3, 0), pt);
  ye = setTimeout(() => {
    ye = null, Et();
  }, n);
}
function tt() {
  ye !== null && (clearTimeout(ye), ye = null);
}
let Ae = null;
function at() {
  return Ae || (Ae = bt()), Ae;
}
async function bt() {
  try {
    return await ft();
  } finally {
    Ae = null;
  }
}
async function ft() {
  const t = localStorage.getItem(ge);
  if (!t)
    return fe(), null;
  let a;
  try {
    a = await fetch(Je + "/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken: t })
    });
  } catch {
    return null;
  }
  if (!a.ok)
    return a.status < 500 && fe(), null;
  const n = await a.json().catch(() => ({}));
  return n.access_token ? (mt(n.access_token, n.refresh_token), n.access_token) : (fe(), null);
}
async function yt() {
  if (Ze())
    return fe(), null;
  const t = et();
  return t && !_t(t) ? t : at();
}
const we = "poc_portal_active_aff:", gt = "X-Active-Com", ht = "X-Active-Dept";
function Ie(t = et()) {
  return t && $e(t).preferred_username || null;
}
function Se(t) {
  if (!t) return null;
  try {
    const a = JSON.parse(t);
    if (Number.isInteger(a == null ? void 0 : a.comSq) && typeof (a == null ? void 0 : a.deptCd) == "string" && a.deptCd)
      return { comSq: a.comSq, deptCd: a.deptCd };
  } catch {
  }
  return null;
}
function De(t = Ie()) {
  if (!t) return null;
  try {
    return Se(localStorage.getItem(we + t));
  } catch {
    return null;
  }
}
function Oc(t, a) {
  if (t)
    try {
      a ? localStorage.setItem(we + t, JSON.stringify(a)) : localStorage.removeItem(we + t);
    } catch {
    }
}
function qc(t) {
  const a = (n) => {
    const o = Ie();
    if (!o || n.key !== we + o) return;
    const r = Se(n.oldValue), s = Se(n.newValue);
    (r == null ? void 0 : r.comSq) === (s == null ? void 0 : s.comSq) && (r == null ? void 0 : r.deptCd) === (s == null ? void 0 : s.deptCd) || t(s, r);
  };
  return window.addEventListener("storage", a), () => window.removeEventListener("storage", a);
}
function vt(t) {
  const a = De(Ie(t));
  return a ? { [gt]: String(a.comSq), [ht]: a.deptCd } : {};
}
async function le(t, a = {}) {
  const n = (s) => {
    var m;
    const l = (m = a.headers) != null ? m : {}, d = Object.keys(l).map((_) => _.toLowerCase()), c = vt(s), i = {};
    return Object.keys(c).forEach((_) => {
      d.indexOf(_.toLowerCase()) < 0 && (i[_] = c[_]);
    }), {
      ...a,
      headers: { ...l, ...s ? { Authorization: "Bearer " + s } : {}, ...i }
    };
  }, o = await yt();
  let r = await fetch(t, n(o));
  if (r.status === 401 && o) {
    const s = await at();
    s && (r = await fetch(t, n(s)));
  }
  return r;
}
const Me = "JPY";
let ve = null;
function nt() {
  return ve || (ve = le(`${Le}/chat-api/api/basicinfo/common/companies`).then((t) => t.ok ? t.json() : []).catch(() => []).then((t) => (t.length || (ve = null), t))), ve;
}
function kt(t, a) {
  var o, r, s;
  const n = (o = t.find((l) => l.comSq === a)) != null ? o : t[0];
  return n && (s = (r = n.dispCurCd) != null ? r : n.baseCurCd) != null ? s : null;
}
function Gc() {
  return nt().then((t) => {
    var n;
    const a = ot(t, (n = De()) == null ? void 0 : n.comSq);
    a && Qe(a);
  }, () => {
  });
}
function ot(t, a) {
  var o, r;
  const n = (o = t.find((s) => s.comSq === a)) != null ? o : t[0];
  return (r = n == null ? void 0 : n.baseCurCd) != null ? r : null;
}
function Nt(t, a) {
  return { code: t, digits: dt(t), fmt: (n) => it(n, t), unit: lt(t, a) };
}
function At(t) {
  const [a, n] = A(Me), [o, r] = A(Me);
  return Z(() => {
    let s = !0;
    return nt().then((l) => {
      var m;
      const d = (m = De()) == null ? void 0 : m.comSq, c = kt(l, d), i = ot(l, d);
      s && (c && n(c), i && (r(i), Qe(i)));
    }), () => {
      s = !1;
    };
  }, []), Nt(a, { base: o, ...t });
}
function zc({ className: t, hideBaseUnit: a = !0 }) {
  const { unit: n } = At({ hideBaseUnit: a });
  return n ? /* @__PURE__ */ e.createElement("span", { className: t, "data-currency-unit": !0 }, n) : null;
}
let ie = Le + "/chat-api/api/comments";
function Wc(t) {
  t.base && (ie = t.base);
}
function wt(t) {
  return t.parentId !== void 0 && t.parentId !== null;
}
async function he(t) {
  const a = await t.json().catch(() => ({}));
  if (!t.ok) throw new Error("요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.");
  return a;
}
async function Te(t, a, n, o, r) {
  const s = new URLSearchParams({ targetType: t, targetId: a, page: String(n), size: String(o) }), l = await le(`${ie}?${s}`, { cache: "no-store", signal: r });
  return he(l);
}
async function $t(t, a, n, o) {
  const r = await le(ie, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ targetType: t, targetId: a, content: n, parentId: o })
  });
  return he(r);
}
async function xt(t, a) {
  const n = await le(`${ie}/${t}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ content: a })
  });
  return he(n);
}
async function Xt(t) {
  const a = await le(`${ie}/${t}`, { method: "DELETE" });
  return (await he(a)).status;
}
async function Ct(t, a, n) {
  if (a.length === 0) return {};
  const o = new URLSearchParams({ targetType: t, targetIds: a.join(",") }), r = await le(`${ie}/counts?${o}`, { cache: "no-store", signal: n });
  return (await he(r)).counts;
}
const Re = 50;
function Fe(t) {
  return t.parentId === void 0 || t.parentId === null;
}
function St(t, a) {
  if (Fe(a)) return [...t, a];
  const n = a.parentId;
  let o = -1;
  for (let r = 0; r < t.length; r += 1)
    (t[r].id === n || t[r].parentId === n) && (o = r);
  return o < 0 ? [...t, a] : [...t.slice(0, o + 1), a, ...t.slice(o + 1)];
}
function me(t, a) {
  return a;
}
function Ft(t, a) {
  const [n, o] = A([]), [r, s] = A(!0), [l, d] = A(!0), [c, i] = A(null), [m, _] = A(0), [u, b] = A(0), y = t + " " + a, E = J(y);
  E.current = y;
  const [h, w] = A(0), X = _e(() => w((f) => f + 1), []);
  Z(() => {
    const f = new AbortController(), v = y;
    return o([]), b(0), _(0), i(null), s(!0), d(!0), Te(t, a, 0, Re, f.signal).then((g) => {
      E.current === v && (o(g.items), _(g.total));
    }).catch((g) => {
      f.signal.aborted || E.current !== v || i(me(g, "댓글을 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && (s(!1), d(!1));
    }), () => f.abort();
  }, [t, a, y, h]);
  const O = n.filter(Fe).length < m, q = _e(() => {
    if (r || !O) return;
    const f = u + 1, v = E.current;
    s(!0), Te(t, a, f, Re).then((g) => {
      E.current === v && (o((S) => [...S, ...g.items]), _(g.total), b(f));
    }).catch((g) => {
      E.current === v && i(me(g, "댓글을 더 불러오지 못했습니다."));
    }).finally(() => {
      E.current === v && s(!1);
    });
  }, [r, O, u, t, a]), V = _e(async (f, v) => {
    const g = f.trim();
    if (!g) return !1;
    const S = -Date.now(), F = {
      id: S,
      targetType: t,
      targetId: a,
      parentId: v != null ? v : null,
      authorName: "나",
      content: g,
      createdAt: (/* @__PURE__ */ new Date()).toISOString(),
      deleted: !1,
      mine: !0,
      pending: !0
    }, D = E.current;
    o((L) => St(L, F)), i(null);
    try {
      const L = await $t(t, a, g, v);
      return E.current !== D || (o((U) => U.map((k) => k.id === S ? L : k)), v === void 0 && _((U) => U + 1)), !0;
    } catch (L) {
      return E.current !== D || (o((U) => U.filter((k) => k.id !== S)), i(me(L, "댓글을 등록하지 못했습니다."))), !1;
    }
  }, [t, a]), C = _e(async (f, v) => {
    const g = v.trim();
    if (!g) return !1;
    const S = E.current;
    try {
      const F = await xt(f, g);
      return E.current !== S || o((D) => D.map((L) => L.id === f ? F : L)), !0;
    } catch (F) {
      return E.current === S && i(me(F, "댓글을 수정하지 못했습니다.")), !1;
    }
  }, []), de = _e(async (f) => {
    const v = E.current;
    try {
      const g = await Xt(f);
      return E.current !== v ? !0 : g === "soft-deleted" ? (o((S) => S.map((F) => F.id === f ? { ...F, deleted: !0, mine: !1, content: void 0, authorName: void 0 } : F)), !0) : (o((S) => {
        const F = S.find((k) => k.id === f), D = S.filter((k) => k.id !== f);
        if (!F) return D;
        if (Fe(F))
          return _((k) => Math.max(0, k - 1)), D;
        const L = F.parentId, U = D.find((k) => k.id === L);
        return U && U.deleted && !D.some((k) => k.parentId === L) ? (_((k) => Math.max(0, k - 1)), D.filter((k) => k.id !== L)) : D;
      }), !0);
    } catch (g) {
      return E.current === v && i(me(g, "댓글을 삭제하지 못했습니다.")), !1;
    }
  }, []);
  return {
    items: n,
    loading: r,
    initialLoading: l,
    error: c,
    count: n.filter((f) => !f.deleted).length,
    hasMore: O,
    loadMore: q,
    reload: X,
    add: V,
    edit: C,
    remove: de
  };
}
const Bt = "_thread_1layy_9", jt = "_head_1layy_28", Lt = "_headTitle_1layy_37", It = "_headCount_1layy_43", Dt = "_list_1layy_54", Mt = "_row_1layy_61", Tt = "_isReply_1layy_73", Rt = "_pending_1layy_80", Pt = "_avatar_1layy_84", Ot = "_avatarGhost_1layy_98", qt = "_body_1layy_103", Gt = "_meta_1layy_108", zt = "_author_1layy_116", Wt = "_dept_1layy_122", Kt = "_time_1layy_130", Ht = "_text_1layy_135", Vt = "_textDeleted_1layy_143", Ut = "_acts_1layy_148", Qt = "_act_1layy_148", Yt = "_actDanger_1layy_169", Jt = "_empty_1layy_175", Zt = "_error_1layy_182", ea = "_skeleton_1layy_196", ta = "_more_1layy_219", aa = "_foot_1layy_245", na = "_composer_1layy_252", oa = "_composerInput_1layy_261", sa = "_composerActions_1layy_284", ra = "_btn_1layy_291", ca = "_btnPrimary_1layy_301", la = "_btnGhost_1layy_310", p = {
  thread: Bt,
  head: jt,
  headTitle: Lt,
  headCount: It,
  list: Dt,
  row: Mt,
  isReply: Tt,
  pending: Rt,
  avatar: Pt,
  avatarGhost: Ot,
  body: qt,
  meta: Gt,
  author: zt,
  dept: Wt,
  time: Kt,
  text: Ht,
  textDeleted: Vt,
  acts: Ut,
  act: Qt,
  actDanger: Yt,
  empty: Jt,
  error: Zt,
  skeleton: ea,
  more: ta,
  foot: aa,
  composer: na,
  composerInput: oa,
  composerActions: sa,
  btn: ra,
  btnPrimary: ca,
  btnGhost: la
}, Pe = ["#3B82F6", "#7C3AED", "#10B981", "#F97316", "#EF4444", "#0EA5E9"];
function ia(t) {
  let a = 0;
  for (let n = 0; n < t.length; n += 1) a = (a * 31 + t.charCodeAt(n)) % 997;
  return Pe[a % Pe.length];
}
function da(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "?";
}
const Oe = 6e4, qe = 36e5, Ge = 864e5, _a = 6048e5;
function ma(t) {
  const a = new Date(t).getTime();
  if (Number.isNaN(a)) return "";
  const n = Date.now() - a;
  if (n < Oe) return "방금";
  if (n < qe) return `${Math.floor(n / Oe)}분 전`;
  if (n < Ge) return `${Math.floor(n / qe)}시간 전`;
  if (n < _a) return `${Math.floor(n / Ge)}일 전`;
  const o = new Date(a), r = (s) => s < 10 ? `0${s}` : String(s);
  return `${o.getFullYear()}.${r(o.getMonth() + 1)}.${r(o.getDate())}`;
}
function Be({
  placeholder: t,
  submitLabel: a,
  autoFocus: n,
  initialValue: o,
  onSubmit: r,
  onCancel: s
}) {
  const [l, d] = A(o != null ? o : ""), [c, i] = A(!1), m = J(null);
  Z(() => {
    n && m.current && m.current.focus();
  }, [n]);
  const _ = async () => {
    const u = l.trim();
    if (!u || c) return;
    i(!0);
    const b = await r(u);
    i(!1), b && d("");
  };
  return /* @__PURE__ */ e.createElement("div", { className: p.composer }, /* @__PURE__ */ e.createElement(
    "textarea",
    {
      ref: m,
      className: p.composerInput,
      rows: o === void 0 ? 2 : 3,
      placeholder: t,
      value: l,
      disabled: c,
      onChange: (u) => d(u.target.value),
      onKeyDown: (u) => {
        const b = u.nativeEvent.isComposing;
        u.key === "Enter" && !u.shiftKey && !b && (u.preventDefault(), _()), u.key === "Escape" && s && (u.nativeEvent.stopPropagation(), s());
      }
    }
  ), /* @__PURE__ */ e.createElement("div", { className: p.composerActions }, s && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: s,
      disabled: c
    },
    "취소"
  ), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnPrimary}`,
      onClick: () => void _(),
      disabled: c || !l.trim()
    },
    c ? "보내는 중…" : a
  )));
}
function ua({
  item: t,
  replying: a,
  editing: n,
  onReply: o,
  onEdit: r,
  onSubmitReply: s,
  onSubmitEdit: l,
  onDelete: d,
  onCancel: c
}) {
  var u, b;
  const i = wt(t), m = i ? ` ${p.isReply}` : "";
  if (t.deleted)
    return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}` }, /* @__PURE__ */ e.createElement("span", { className: `${p.avatar} ${p.avatarGhost}` }, "·"), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: `${p.text} ${p.textDeleted}` }, "삭제된 댓글입니다")));
  const _ = (u = t.authorName) != null ? u : "anonymous";
  return /* @__PURE__ */ e.createElement("div", { className: `${p.row}${m}${t.pending ? ` ${p.pending}` : ""}` }, /* @__PURE__ */ e.createElement("span", { className: p.avatar, style: { background: ia(_) } }, da(_)), /* @__PURE__ */ e.createElement("div", { className: p.body }, /* @__PURE__ */ e.createElement("div", { className: p.meta }, /* @__PURE__ */ e.createElement("span", { className: p.author }, _), t.dept && /* @__PURE__ */ e.createElement("span", { className: p.dept }, t.dept), /* @__PURE__ */ e.createElement("span", { className: p.time }, ma(t.createdAt)), t.updatedAt && /* @__PURE__ */ e.createElement("span", { className: p.time }, "(수정됨)")), n ? /* @__PURE__ */ e.createElement(
    Be,
    {
      placeholder: "댓글을 수정합니다",
      submitLabel: "수정",
      autoFocus: !0,
      initialValue: (b = t.content) != null ? b : "",
      onSubmit: l,
      onCancel: c
    }
  ) : /* @__PURE__ */ e.createElement("div", { className: p.text }, t.content), !n && !t.pending && /* @__PURE__ */ e.createElement("div", { className: p.acts }, !i && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: o }, "답글"), t.mine && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.act, onClick: r }, "수정"), t.mine && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.act} ${p.actDanger}`,
      onClick: d
    },
    "삭제"
  )), a && /* @__PURE__ */ e.createElement(
    Be,
    {
      placeholder: `${_} 님에게 답글`,
      submitLabel: "답글 등록",
      autoFocus: !0,
      onSubmit: s,
      onCancel: c
    }
  )));
}
function Kc({
  targetType: t,
  targetId: a,
  onCountChange: n,
  autoFocus: o,
  showHeader: r = !0,
  className: s,
  style: l
}) {
  const { items: d, initialLoading: c, loading: i, error: m, count: _, hasMore: u, loadMore: b, reload: y, add: E, edit: h, remove: w } = Ft(t, a), [X, T] = A(null), [O, q] = A(null);
  Z(() => {
    T(null), q(null);
  }, [t, a]);
  const V = J(n);
  return V.current = n, Z(() => {
    !c && V.current && V.current(_);
  }, [_, c]), /* @__PURE__ */ e.createElement("div", { className: s ? `${p.thread} ${s}` : p.thread, style: l }, r && /* @__PURE__ */ e.createElement("div", { className: p.head }, /* @__PURE__ */ e.createElement("span", { className: p.headTitle }, "댓글"), /* @__PURE__ */ e.createElement("span", { className: p.headCount }, _)), /* @__PURE__ */ e.createElement("div", { className: p.list }, c && /* @__PURE__ */ e.createElement("div", { className: p.skeleton }, /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null), /* @__PURE__ */ e.createElement("span", null)), m && /* @__PURE__ */ e.createElement("div", { className: p.error }, /* @__PURE__ */ e.createElement("span", null, m), /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${p.btn} ${p.btnGhost}`,
      onClick: y
    },
    "다시 시도"
  )), !c && !m && d.length === 0 && /* @__PURE__ */ e.createElement("div", { className: p.empty }, "첫 댓글을 남겨 보세요."), d.map((C) => /* @__PURE__ */ e.createElement(
    ua,
    {
      key: C.id,
      item: C,
      replying: X === C.id,
      editing: O === C.id,
      onReply: () => {
        q(null), T(C.id);
      },
      onEdit: () => {
        T(null), q(C.id);
      },
      onCancel: () => {
        T(null), q(null);
      },
      onSubmitReply: async (de) => {
        const f = await E(de, C.id);
        return f && T(null), f;
      },
      onSubmitEdit: async (de) => {
        const f = await h(C.id, de);
        return f && q(null), f;
      },
      onDelete: () => {
        w(C.id);
      }
    }
  )), u && /* @__PURE__ */ e.createElement("button", { type: "button", className: p.more, onClick: b, disabled: i }, i ? "불러오는 중…" : "이전 댓글 더 보기")), /* @__PURE__ */ e.createElement("div", { className: p.foot }, /* @__PURE__ */ e.createElement(
    Be,
    {
      placeholder: "댓글을 입력하세요 (Enter 전송, Shift+Enter 줄바꿈)",
      submitLabel: "등록",
      autoFocus: o,
      onSubmit: (C) => E(C)
    }
  )));
}
function Hc(t, a) {
  const [n, o] = A({}), [r, s] = A(!1), [l, d] = A(0), c = a.join(",");
  return Z(() => {
    const i = c ? c.split(",") : [];
    if (i.length === 0) {
      o({});
      return;
    }
    const m = new AbortController();
    return s(!0), Ct(t, i, m.signal).then((_) => {
      m.signal.aborted || o(_);
    }).catch(() => {
      m.signal.aborted || o({});
    }).finally(() => {
      m.signal.aborted || s(!1);
    }), () => m.abort();
  }, [t, c, l]), {
    counts: n,
    loading: r,
    reload: () => d((i) => i + 1)
  };
}
const pa = "_card_epi3f_1", Ea = "_header_epi3f_8", ba = "_headerNoDivider_epi3f_13", fa = "_body_epi3f_17", ya = "_paddingSm_epi3f_22", ga = "_paddingMd_epi3f_26", ha = "_paddingLg_epi3f_30", G = {
  card: pa,
  header: Ea,
  headerNoDivider: ba,
  body: fa,
  paddingSm: ya,
  paddingMd: ga,
  paddingLg: ha
};
function Vc({
  children: t,
  header: a,
  padding: n = "md",
  radius: o,
  headerDivider: r = !0,
  headerBackground: s,
  headerPadding: l,
  headerBorderColor: d,
  className: c
}) {
  const i = typeof n == "number" ? "" : n === "sm" ? G.paddingSm : n === "lg" ? G.paddingLg : G.paddingMd, m = typeof n == "number" ? { padding: n } : void 0, _ = c ? `${G.card} ${c}` : G.card, u = r ? G.header : `${G.header} ${G.headerNoDivider}`, b = {
    ...s !== void 0 ? { background: s } : {},
    ...l !== void 0 ? { padding: l } : {},
    ...d !== void 0 ? { borderBottomColor: d } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: _, style: o !== void 0 ? { borderRadius: o } : void 0 }, a && /* @__PURE__ */ e.createElement("div", { className: u, style: b }, a), /* @__PURE__ */ e.createElement("div", { className: `${G.body} ${i}`, style: m }, t));
}
const va = "_horizontal_mkht7_1", ka = "_vertical_mkht7_8", ze = {
  horizontal: va,
  vertical: ka
};
function Uc({ orientation: t = "horizontal", spacing: a = 0, color: n }) {
  const o = t === "vertical";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: o ? ze.vertical : ze.horizontal,
      style: {
        ...o ? { marginLeft: a, marginRight: a } : { marginTop: a, marginBottom: a },
        ...n !== void 0 ? { backgroundColor: n } : {}
      },
      role: "separator",
      "aria-orientation": t
    }
  );
}
const Na = "_root_nvy8t_1", Aa = "_icon_nvy8t_7", wa = "_iconBadge_nvy8t_15", $a = "_titleGroup_nvy8t_25", xa = "_title_nvy8t_25", Xa = "_subtitle_nvy8t_41", Ca = "_trailing_nvy8t_49", Sa = "_closeButton_nvy8t_58", Q = {
  root: Na,
  icon: Aa,
  iconBadge: wa,
  titleGroup: $a,
  title: xa,
  subtitle: Xa,
  trailing: Ca,
  closeButton: Sa
};
function Qc({
  icon: t,
  iconColor: a,
  iconBadge: n = !1,
  iconBadgeColor: o = "#3b82f6",
  iconBadgeGradient: r,
  iconBadgeSize: s,
  title: l,
  titleWeight: d,
  titleSize: c,
  subtitle: i,
  subtitleColor: m,
  subtitleSize: _,
  trailing: u,
  onClose: b
}) {
  const y = {
    ...d !== void 0 ? { fontWeight: d } : {},
    ...c !== void 0 ? { fontSize: c } : {}
  }, E = {
    ...m !== void 0 ? { color: m } : {},
    ..._ !== void 0 ? { fontSize: _ } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: Q.root }, t && n && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Q.iconBadge,
      style: {
        ...r ? { background: `linear-gradient(135deg, ${r[0]}, ${r[1]})`, color: "#fff" } : { backgroundColor: `${o}1A`, color: o },
        ...s !== void 0 ? { width: s, height: s } : {}
      }
    },
    t
  ), t && !n && /* @__PURE__ */ e.createElement("span", { className: Q.icon, style: a !== void 0 ? { color: a } : void 0 }, t), /* @__PURE__ */ e.createElement("div", { className: Q.titleGroup }, /* @__PURE__ */ e.createElement("span", { className: Q.title, style: y }, l), i && /* @__PURE__ */ e.createElement("span", { className: Q.subtitle, style: E }, i)), u && /* @__PURE__ */ e.createElement("div", { className: Q.trailing }, u), b && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: Q.closeButton,
      onClick: b,
      "aria-label": "닫기"
    },
    "×"
  ));
}
const Fa = "_badge_19977_1", Ba = {
  badge: Fa
};
function Yc({
  size: t = 32,
  gradient: a = ["#7C3AED", "#3B82F6"],
  icon: n
}) {
  const o = t * 0.55;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ba.badge,
      style: {
        width: t,
        height: t,
        background: `linear-gradient(135deg, ${a[0]}, ${a[1]})`
      }
    },
    n != null ? n : /* @__PURE__ */ e.createElement("svg", { width: o, height: o, viewBox: "0 0 24 24", fill: "#fff" }, /* @__PURE__ */ e.createElement("path", { d: "M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z" }))
  );
}
const ja = "_wrapper_ccmq2_1", La = "_image_ccmq2_8", Ia = "_fallback_ccmq2_16", Da = "_statusDot_ccmq2_29", ke = {
  wrapper: ja,
  image: La,
  fallback: Ia,
  statusDot: Da
}, Ma = {
  on: "#22C55E",
  away: "#F59E0B",
  off: "#94A3B8"
};
function Ta(t) {
  const a = t == null ? void 0 : t.trim();
  return a ? Array.from(a)[0].toUpperCase() : "";
}
const xe = [
  "#EF4444",
  "#F97316",
  "#F59E0B",
  "#10B981",
  "#0EA5E9",
  "#3B82F6",
  "#6366F1",
  "#8B5CF6",
  "#D946EF",
  "#EC4899"
];
function Ra(t) {
  const a = t == null ? void 0 : t.trim();
  if (!a) return xe[5];
  let n = 0;
  for (let o = 0; o < a.length; o += 1)
    n = n * 31 + a.charCodeAt(o) | 0;
  return xe[Math.abs(n) % xe.length];
}
function st({
  src: t,
  fallbackText: a,
  alt: n,
  size: o = 32,
  statusDot: r,
  color: s,
  ring: l = !1,
  ringColor: d = "#fff"
}) {
  var _;
  const [c, i] = A(), m = !!t && c !== t;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: ke.wrapper,
      style: {
        width: o,
        height: o,
        ...l ? { boxShadow: `0 0 0 2px ${d}` } : {}
      }
    },
    m ? /* @__PURE__ */ e.createElement(
      "img",
      {
        className: ke.image,
        src: t,
        alt: (_ = n != null ? n : a) != null ? _ : "",
        onError: () => i(t)
      }
    ) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.fallback,
        style: {
          backgroundColor: s != null ? s : Ra(a),
          fontSize: Math.max(10, o * 0.45)
        }
      },
      Ta(a)
    ),
    r && /* @__PURE__ */ e.createElement(
      "span",
      {
        className: ke.statusDot,
        style: {
          backgroundColor: Ma[r],
          width: Math.max(8, o * 0.28),
          height: Math.max(8, o * 0.28)
        }
      }
    )
  );
}
const Pa = "_stack_y8phg_1", Oa = "_item_y8phg_6", qa = "_overflow_y8phg_18", Ne = {
  stack: Pa,
  item: Oa,
  overflow: qa
};
function Jc({
  avatars: t,
  max: a = 4,
  size: n = 32
}) {
  const o = t.slice(0, a), r = t.length - o.length;
  return /* @__PURE__ */ e.createElement("span", { className: Ne.stack }, o.map((s, l) => /* @__PURE__ */ e.createElement("span", { key: l, className: Ne.item, style: { zIndex: o.length - l } }, /* @__PURE__ */ e.createElement(st, { src: s.src, alt: s.alt, fallbackText: s.fallbackText, size: n }))), r > 0 && /* @__PURE__ */ e.createElement("span", { className: Ne.item, style: { zIndex: 0 } }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: Ne.overflow,
      style: { width: n, height: n, fontSize: Math.max(10, n * 0.36) }
    },
    "+",
    r
  )));
}
const Ga = "_badge_1mjda_1", za = "_pill_1mjda_15", Wa = "_dot_1mjda_19", Ka = "_dotPulse_1mjda_26", Ha = "_outline_1mjda_40", Va = "_soft_1mjda_46", ue = {
  badge: Ga,
  pill: za,
  dot: Wa,
  dotPulse: Ka,
  "ax-badge-pulse": "_ax-badge-pulse_1mjda_1",
  default: "_default_1mjda_35",
  outline: Ha,
  soft: Va
};
function Zc({
  label: t,
  variant: a = "default",
  color: n,
  background: o,
  textColor: r,
  shape: s = "rounded",
  dot: l = !1,
  dotColor: d,
  dotPulse: c = !1,
  border: i = !1,
  borderColor: m = "currentColor"
}) {
  var y;
  const _ = {};
  n && (a === "default" ? (_.backgroundColor = n, _.color = "#fff") : a === "outline" ? (_.borderColor = n, _.color = n) : (_.backgroundColor = `${n}1A`, _.color = n)), o !== void 0 && (_.backgroundColor = o), r !== void 0 && (_.color = r), i && (_.borderColor = m);
  const u = [
    ue.badge,
    ue[a],
    s === "pill" ? ue.pill : ""
  ].filter(Boolean).join(" "), b = [ue.dot, c ? ue.dotPulse : ""].filter(Boolean).join(" ");
  return /* @__PURE__ */ e.createElement("span", { className: u, style: _ }, l && /* @__PURE__ */ e.createElement("span", { className: b, style: { backgroundColor: d != null ? d : (y = r != null ? r : n) != null ? y : "currentColor" } }), t);
}
const Ua = "_row_1k2ap_1", Qa = "_reply_1k2ap_7", Ya = "_avatar_1k2ap_12", Ja = "_avatarImage_1k2ap_25", Za = "_avatarFallback_1k2ap_32", en = "_body_1k2ap_44", tn = "_headerLine_1k2ap_49", an = "_author_1k2ap_56", nn = "_meta_1k2ap_62", on = "_text_1k2ap_67", sn = "_actionsRow_1k2ap_74", rn = "_actionBtn_1k2ap_81", B = {
  row: Ua,
  reply: Qa,
  avatar: Ya,
  avatarImage: Ja,
  avatarFallback: Za,
  body: en,
  headerLine: tn,
  author: an,
  meta: nn,
  text: on,
  actionsRow: sn,
  actionBtn: rn
};
function cn(t) {
  const a = t.trim();
  return a ? a[0].toUpperCase() : "";
}
function el({
  avatarSrc: t,
  author: a,
  meta: n,
  text: o,
  likeCount: r,
  replyCount: s,
  isReply: l = !1,
  onLikeClick: d,
  onReplyClick: c
}) {
  const [i, m] = A(!1), _ = !!t && !i;
  return /* @__PURE__ */ e.createElement("div", { className: `${B.row} ${l ? B.reply : ""}` }, /* @__PURE__ */ e.createElement("span", { className: B.avatar }, _ ? /* @__PURE__ */ e.createElement(
    "img",
    {
      className: B.avatarImage,
      src: t,
      alt: a,
      onError: () => m(!0)
    }
  ) : /* @__PURE__ */ e.createElement("span", { className: B.avatarFallback }, cn(a))), /* @__PURE__ */ e.createElement("div", { className: B.body }, /* @__PURE__ */ e.createElement("div", { className: B.headerLine }, /* @__PURE__ */ e.createElement("span", { className: B.author }, a), n && /* @__PURE__ */ e.createElement("span", { className: B.meta }, n)), /* @__PURE__ */ e.createElement("div", { className: B.text }, o), /* @__PURE__ */ e.createElement("div", { className: B.actionsRow }, /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: d }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" })), typeof r == "number" && /* @__PURE__ */ e.createElement("span", null, r)), /* @__PURE__ */ e.createElement("button", { type: "button", className: B.actionBtn, onClick: c }, /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })), typeof s == "number" && /* @__PURE__ */ e.createElement("span", null, s)))));
}
const ln = "_wrapper_79n51_1", dn = {
  wrapper: ln
}, _n = {
  pdf: { label: "PDF", color: "#B91C1C", bg: "#FEF2F2" },
  doc: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  docx: { label: "DOC", color: "#1D4ED8", bg: "#EFF6FF" },
  xls: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  xlsx: { label: "XLS", color: "#166534", bg: "#F0FDF4" },
  ppt: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  pptx: { label: "PPT", color: "#92400E", bg: "#FFFBEB" },
  zip: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  rar: { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  "7z": { label: "ZIP", color: "#64748B", bg: "#F1F5F9" },
  jpg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  jpeg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  png: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  gif: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  svg: { label: "IMG", color: "#3B82F6", bg: "#EFF6FF" },
  mp4: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  mov: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  avi: { label: "VID", color: "#334155", bg: "#F1F5F9" },
  txt: { label: "TXT", color: "#334155", bg: "#F8FAFC" }
}, mn = { label: "FILE", color: "#64748B", bg: "#F1F5F9" };
function un({ ext: t, size: a = 32 }) {
  var l;
  const n = t.trim().toLowerCase().replace(/^\./, ""), { label: o, color: r, bg: s } = (l = _n[n]) != null ? l : mn;
  return /* @__PURE__ */ e.createElement(
    "span",
    {
      className: dn.wrapper,
      style: {
        width: a,
        height: a,
        backgroundColor: s,
        color: r,
        fontSize: Math.max(8, a * 0.26)
      }
    },
    o
  );
}
const pn = "_chip_1jhj8_1", En = "_clickable_1jhj8_12", bn = "_icon_1jhj8_21", fn = "_info_1jhj8_26", yn = "_name_1jhj8_33", gn = "_size_1jhj8_42", hn = "_chipError_1jhj8_48", vn = "_chipDone_1jhj8_53", kn = "_status_1jhj8_57", Nn = "_statusError_1jhj8_66", An = "_statusDone_1jhj8_67", wn = "_statusIcon_1jhj8_69", $n = "_statusLabel_1jhj8_71", xn = "_progressTrack_1jhj8_78", Xn = "_progressFill_1jhj8_88", Cn = "_actionBtn_1jhj8_96", N = {
  chip: pn,
  clickable: En,
  icon: bn,
  info: fn,
  name: yn,
  size: gn,
  chipError: hn,
  chipDone: vn,
  status: kn,
  statusError: Nn,
  statusDone: An,
  statusIcon: wn,
  statusLabel: $n,
  progressTrack: xn,
  progressFill: Xn,
  actionBtn: Cn
};
function tl({
  name: t,
  ext: a,
  size: n,
  onRemove: o,
  downloadable: r = !1,
  onClick: s,
  status: l,
  statusText: d,
  percent: c
}) {
  const i = l === "error" ? N.chipError : l === "done" ? N.chipDone : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${N.chip} ${s ? N.clickable : ""} ${i}`,
      onClick: s,
      title: l === "error" ? d : void 0
    },
    a && /* @__PURE__ */ e.createElement("span", { className: N.icon }, /* @__PURE__ */ e.createElement(un, { ext: a, size: 28 })),
    /* @__PURE__ */ e.createElement("span", { className: N.info }, /* @__PURE__ */ e.createElement("span", { className: N.name }, t), d ? /* @__PURE__ */ e.createElement("span", { className: `${N.status} ${l === "error" ? N.statusError : l === "done" ? N.statusDone : ""}` }, l === "error" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round" }, /* @__PURE__ */ e.createElement("circle", { cx: "12", cy: "12", r: "9" }), /* @__PURE__ */ e.createElement("path", { d: "M12 7v6M12 16.5v.01" })), l === "done" && /* @__PURE__ */ e.createElement("svg", { className: N.statusIcon, width: "11", height: "11", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M4 12.5l5 5L20 6.5" })), /* @__PURE__ */ e.createElement("span", { className: N.statusLabel }, d)) : n ? /* @__PURE__ */ e.createElement("span", { className: N.size }, n) : null, l === "processing" && /* @__PURE__ */ e.createElement("span", { className: N.progressTrack }, /* @__PURE__ */ e.createElement("span", { className: N.progressFill, style: { width: `${Math.max(0, Math.min(100, c != null ? c : 0))}%` } }))),
    r ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "내려받기",
        onClick: (m) => m.stopPropagation()
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M12 3v12M7 10l5 5 5-5M4 21h16" }))
    ) : o ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: N.actionBtn,
        "aria-label": "삭제",
        onClick: (m) => {
          m.stopPropagation(), o();
        }
      },
      /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18M6 6l12 12" }))
    ) : null
  );
}
const Sn = "_list_1yxwc_1", Fn = "_row_1yxwc_6", Bn = "_inline_1yxwc_15", jn = "_label_1yxwc_22", Ln = "_value_1yxwc_29", In = "_stacked_1yxwc_35", Dn = "_bold_1yxwc_51", ne = {
  list: Sn,
  row: Fn,
  inline: Bn,
  label: jn,
  value: Ln,
  stacked: In,
  bold: Dn
};
function al({
  rows: t,
  direction: a = "inline"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: `${ne.list} ${ne[a]}` }, t.map((n, o) => /* @__PURE__ */ e.createElement("div", { key: o, className: ne.row }, /* @__PURE__ */ e.createElement("span", { className: ne.label }, n.label), /* @__PURE__ */ e.createElement("span", { className: `${ne.value} ${n.bold ? ne.bold : ""}` }, n.value))));
}
const Mn = "_container_2r163_1", Tn = "_row_2r163_5", Rn = "_clickable_2r163_12", Pn = "_leading_2r163_20", On = "_main_2r163_26", qn = "_titleLine_2r163_34", Gn = "_title_2r163_34", zn = "_tags_2r163_50", Wn = "_meta_2r163_57", Kn = "_actions_2r163_62", Hn = "_expandable_2r163_69", M = {
  container: Mn,
  row: Tn,
  clickable: Rn,
  leading: Pn,
  main: On,
  titleLine: qn,
  title: Gn,
  tags: zn,
  meta: Wn,
  actions: Kn,
  expandable: Hn
};
function nl({
  leading: t,
  title: a,
  meta: n,
  tags: o,
  actions: r,
  expandableContent: s,
  expanded: l = !1,
  onClick: d
}) {
  return /* @__PURE__ */ e.createElement("div", { className: M.container }, /* @__PURE__ */ e.createElement("div", { className: `${M.row} ${d ? M.clickable : ""}`, onClick: d }, t && /* @__PURE__ */ e.createElement("div", { className: M.leading }, t), /* @__PURE__ */ e.createElement("div", { className: M.main }, /* @__PURE__ */ e.createElement("div", { className: M.titleLine }, /* @__PURE__ */ e.createElement("span", { className: M.title }, a), o && /* @__PURE__ */ e.createElement("span", { className: M.tags }, o)), n && /* @__PURE__ */ e.createElement("div", { className: M.meta }, n)), r && /* @__PURE__ */ e.createElement("div", { className: M.actions, onClick: (c) => c.stopPropagation() }, r)), l && s && /* @__PURE__ */ e.createElement("div", { className: M.expandable }, s));
}
const Vn = "_row_xzgny_1", Un = "_info_xzgny_8", Qn = "_name_xzgny_16", Yn = "_subtitle_xzgny_25", Jn = "_status_xzgny_33", pe = {
  row: Vn,
  info: Un,
  name: Qn,
  subtitle: Yn,
  status: Jn
};
function ol({
  avatarSrc: t,
  name: a,
  subtitle: n,
  status: o,
  statusColor: r = "#64748B",
  statusBg: s = "#F1F5F9"
}) {
  return /* @__PURE__ */ e.createElement("div", { className: pe.row }, /* @__PURE__ */ e.createElement(st, { src: t, fallbackText: a, size: 36 }), /* @__PURE__ */ e.createElement("div", { className: pe.info }, /* @__PURE__ */ e.createElement("span", { className: pe.name }, a), n && /* @__PURE__ */ e.createElement("span", { className: pe.subtitle }, n)), o && /* @__PURE__ */ e.createElement(
    "span",
    {
      className: pe.status,
      style: { color: r, backgroundColor: s }
    },
    o
  ));
}
const Zn = "_row_qoxwr_1", eo = "_clickable_qoxwr_9", to = "_rank_qoxwr_17", ao = "_title_qoxwr_25", no = "_trailing_qoxwr_36", Ee = {
  row: Zn,
  clickable: eo,
  rank: to,
  title: ao,
  trailing: no
}, oo = {
  1: "#F59E0B",
  2: "#94A3B8",
  3: "#B45309"
};
function sl({
  rank: t,
  rankColor: a,
  title: n,
  trailingText: o,
  onClick: r
}) {
  var l;
  const s = (l = a != null ? a : oo[t]) != null ? l : "#64748B";
  return /* @__PURE__ */ e.createElement("div", { className: `${Ee.row} ${r ? Ee.clickable : ""}`, onClick: r }, /* @__PURE__ */ e.createElement("span", { className: Ee.rank, style: { color: s } }, t), /* @__PURE__ */ e.createElement("span", { className: Ee.title }, n), o && /* @__PURE__ */ e.createElement("span", { className: Ee.trailing }, o));
}
const so = "_badge_1qibj_1", ro = "_sm_1qibj_11", co = "_md_1qibj_16", lo = "_overdue_1qibj_21", io = "_warning_1qibj_26", _o = "_progress_1qibj_31", mo = "_success_1qibj_36", uo = "_info_1qibj_41", po = "_neutral_1qibj_46", Xe = {
  badge: so,
  sm: ro,
  md: co,
  overdue: lo,
  warning: io,
  progress: _o,
  success: mo,
  info: uo,
  neutral: po
};
function rl({
  label: t,
  tone: a = "neutral",
  size: n = "md",
  background: o,
  textColor: r
}) {
  const s = {};
  return o !== void 0 && (s.backgroundColor = o), r !== void 0 && (s.color = r), /* @__PURE__ */ e.createElement("span", { className: `${Xe.badge} ${Xe[a]} ${Xe[n]}`, style: s }, t);
}
const Eo = "_wrapper_14p14_1", bo = "_avatar_14p14_11", fo = "_body_14p14_21", yo = "_message_14p14_26", go = "_dots_14p14_32", ho = "_dot_14p14_32", vo = "_action_14p14_70", ko = "_actionIcon_14p14_89", No = "_gradientWrapper_14p14_95", Ao = "_bareIcon_14p14_100", wo = "_ctaButton_14p14_109", $ = {
  wrapper: Eo,
  avatar: bo,
  body: fo,
  message: yo,
  dots: go,
  dot: ho,
  action: vo,
  actionIcon: ko,
  gradientWrapper: No,
  bareIcon: Ao,
  ctaButton: wo
};
function We() {
  return /* @__PURE__ */ e.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8 1.5l1.4 3.9L13.3 6.8l-3.9 1.4L8 12.1l-1.4-3.9L2.7 6.8l3.9-1.4L8 1.5z",
      fill: "currentColor"
    }
  ));
}
function Ke() {
  return /* @__PURE__ */ e.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3 7h8M7.5 3.5L11 7l-3.5 3.5",
      stroke: "currentColor",
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ));
}
function cl({
  message: t,
  accentColor: a = "#7C3AED",
  buttonLabel: n,
  buttonIcon: o,
  onAction: r,
  phase: s = "complete",
  variant: l = "card",
  gradientColors: d = ["#EEF4FF", "#F3EEFF"]
}) {
  const c = l === "gradient-cta";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [$.wrapper, c ? $.gradientWrapper : ""].join(" "),
      style: c ? { borderColor: `${a}33`, background: `linear-gradient(135deg, ${d[0]}, ${d[1]})` } : { borderColor: `${a}33` }
    },
    c ? /* @__PURE__ */ e.createElement("span", { className: $.bareIcon, style: { color: a } }, /* @__PURE__ */ e.createElement(We, null)) : /* @__PURE__ */ e.createElement(
      "span",
      {
        className: $.avatar,
        style: { backgroundColor: `${a}1A`, color: a }
      },
      /* @__PURE__ */ e.createElement(We, null)
    ),
    /* @__PURE__ */ e.createElement("div", { className: $.body }, s === "loading" ? /* @__PURE__ */ e.createElement("span", { className: $.dots }, /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } }), /* @__PURE__ */ e.createElement("span", { className: $.dot, style: { backgroundColor: a } })) : /* @__PURE__ */ e.createElement("span", { className: $.message, style: c ? { color: a } : void 0 }, t)),
    n && r && (c ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.ctaButton,
        style: { backgroundColor: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ke, null) : o)
    ) : /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: $.action,
        style: { color: a },
        onClick: r
      },
      /* @__PURE__ */ e.createElement("span", null, n),
      /* @__PURE__ */ e.createElement("span", { className: $.actionIcon }, o === void 0 ? /* @__PURE__ */ e.createElement(Ke, null) : o)
    ))
  );
}
const $o = "_wrapper_68zkp_1", xo = "_bordered_68zkp_13", Xo = "_compact_68zkp_17", Co = "_icon_68zkp_23", So = "_title_68zkp_31", Fo = "_description_68zkp_38", Bo = "_action_68zkp_46", ee = {
  wrapper: $o,
  bordered: xo,
  compact: Xo,
  icon: Co,
  title: So,
  description: Fo,
  action: Bo
};
function jo() {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15L20 8l14 7-14 7-14-7z",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 15v11l14 7 14-7V15",
        stroke: "#94A3B8",
        strokeWidth: "1.6",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ e.createElement("path", { d: "M20 22v11", stroke: "#94A3B8", strokeWidth: "1.6", strokeLinecap: "round" })
  );
}
function ll({
  icon: t,
  hideIcon: a = !1,
  title: n,
  titleColor: o,
  titleSize: r,
  titleWeight: s,
  description: l,
  actionLabel: d,
  onAction: c,
  bordered: i = !0,
  compact: m = !1
}) {
  const _ = {
    ...o !== void 0 ? { color: o } : {},
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [ee.wrapper, i && !m ? ee.bordered : "", m ? ee.compact : ""].join(" ")
    },
    !a && /* @__PURE__ */ e.createElement("div", { className: ee.icon }, t != null ? t : /* @__PURE__ */ e.createElement(jo, null)),
    /* @__PURE__ */ e.createElement("p", { className: ee.title, style: _ }, n),
    l && /* @__PURE__ */ e.createElement("p", { className: ee.description }, l),
    d && c && /* @__PURE__ */ e.createElement("button", { type: "button", className: ee.action, onClick: c }, d)
  );
}
const Lo = "_wrapper_oide4_1", Io = "_toggle_oide4_7", Do = "_toggleOpen_oide4_29", Mo = "_panel_oide4_34", To = "_text_oide4_41", be = {
  wrapper: Lo,
  toggle: Io,
  toggleOpen: Do,
  panel: Mo,
  text: To
};
function il({
  label: t,
  summaryText: a,
  open: n,
  onToggle: o
}) {
  return /* @__PURE__ */ e.createElement("div", { className: be.wrapper }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: [be.toggle, n ? be.toggleOpen : ""].join(" "),
      onClick: o,
      "aria-expanded": n
    },
    t
  ), n && /* @__PURE__ */ e.createElement("div", { className: be.panel }, /* @__PURE__ */ e.createElement("p", { className: be.text }, a)));
}
const Ro = "_wrapper_96dw1_1", Po = "_labelRow_96dw1_8", Oo = "_label_96dw1_8", qo = "_value_96dw1_21", Go = "_track_96dw1_27", zo = "_xs_96dw1_35", Wo = "_sm_96dw1_39", Ko = "_md_96dw1_43", Ho = "_square_96dw1_47", Vo = "_fill_96dw1_51", z = {
  wrapper: Ro,
  labelRow: Po,
  label: Oo,
  value: qo,
  track: Go,
  xs: zo,
  sm: Wo,
  md: Ko,
  square: Ho,
  fill: Vo
};
function dl({
  value: t,
  max: a = 100,
  label: n,
  color: o = "#3B82F6",
  gradient: r,
  size: s = "md",
  rounded: l = !0,
  height: d,
  trackColor: c
}) {
  const i = a > 0 ? a : 100, m = Math.min(100, Math.max(0, t / i * 100)), _ = r ? { width: `${m}%`, background: `linear-gradient(90deg, ${r[0]}, ${r[1]})` } : { width: `${m}%`, backgroundColor: o }, u = {
    ...d !== void 0 ? { height: d } : {},
    ...c !== void 0 ? { background: c } : {}
  };
  return /* @__PURE__ */ e.createElement("div", { className: z.wrapper }, n && /* @__PURE__ */ e.createElement("div", { className: z.labelRow }, /* @__PURE__ */ e.createElement("span", { className: z.label }, n), /* @__PURE__ */ e.createElement("span", { className: z.value }, Math.round(m), "%")), /* @__PURE__ */ e.createElement("div", { className: [z.track, z[s], l ? "" : z.square].join(" "), style: u }, /* @__PURE__ */ e.createElement("div", { className: [z.fill, l ? "" : z.square].join(" "), style: _ })));
}
const Uo = "_list_aixh6_1", Qo = "_vertical_aixh6_8", Yo = "_horizontal_aixh6_13", Jo = "_item_aixh6_18", Zo = "_iconWrap_aixh6_41", es = "_iconSvg_aixh6_51", ts = "_spin_aixh6_56", as = "_label_aixh6_70", ns = "_item_active_aixh6_82", os = "_item_done_aixh6_87", ss = "_connector_aixh6_91", rs = "_cardList_aixh6_114", cs = "_cardItem_aixh6_122", ls = "_card_pending_aixh6_133", is = "_card_active_aixh6_142", ds = "_card_done_aixh6_152", x = {
  list: Uo,
  vertical: Qo,
  horizontal: Yo,
  item: Jo,
  iconWrap: Zo,
  iconSvg: es,
  spin: ts,
  "ax-step-spin": "_ax-step-spin_aixh6_1",
  label: as,
  item_active: ns,
  item_done: os,
  connector: ss,
  cardList: rs,
  cardItem: cs,
  card_pending: ls,
  card_active: is,
  card_done: ds
};
function _s({ status: t }) {
  return t === "done" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "9", fill: "#F0FDF4", stroke: "#166534", strokeWidth: "1.5" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M6 10.2l2.4 2.4L14 7",
        stroke: "#166534",
        strokeWidth: "1.7",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ) : t === "active" ? /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: [x.iconSvg, x.spin].join(" "),
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "#E2E8F0",
        strokeWidth: "2.5"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M18 10a8 8 0 00-8-8",
        stroke: "#3B82F6",
        strokeWidth: "2.5",
        strokeLinecap: "round"
      }
    )
  ) : /* @__PURE__ */ e.createElement(
    "svg",
    {
      className: x.iconSvg,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ e.createElement("circle", { cx: "10", cy: "10", r: "8", stroke: "#94A3B8", strokeWidth: "1.5" })
  );
}
function _l({
  steps: t,
  orientation: a = "vertical",
  variant: n = "timeline"
}) {
  const o = n === "card";
  return /* @__PURE__ */ e.createElement("ul", { className: [x.list, x[a], o ? x.cardList : ""].join(" ") }, t.map((r, s) => /* @__PURE__ */ e.createElement(
    "li",
    {
      key: `${r.label}-${s}`,
      className: [
        x.item,
        o ? x.cardItem : "",
        x[`item_${r.status}`],
        o ? x[`card_${r.status}`] : ""
      ].join(" ")
    },
    /* @__PURE__ */ e.createElement("span", { className: x.iconWrap }, /* @__PURE__ */ e.createElement(_s, { status: r.status })),
    /* @__PURE__ */ e.createElement("span", { className: x.label }, r.label),
    !o && s < t.length - 1 && /* @__PURE__ */ e.createElement("span", { className: x.connector })
  )));
}
const ms = "_wrapper_1ohmw_1", us = "_icon_1ohmw_7", ps = "_dots_1ohmw_14", Es = "_dot_1ohmw_14", bs = "_sm_1ohmw_27", fs = "_md_1ohmw_32", te = {
  wrapper: ms,
  icon: us,
  dots: ps,
  dot: Es,
  "ax-typing-bounce": "_ax-typing-bounce_1ohmw_1",
  sm: bs,
  md: fs
};
function ml({ withIcon: t, size: a = "md" }) {
  return /* @__PURE__ */ e.createElement("div", { className: te.wrapper }, t && /* @__PURE__ */ e.createElement("span", { className: te.icon }, t), /* @__PURE__ */ e.createElement("span", { className: [te.dots, te[a]].join(" ") }, /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot }), /* @__PURE__ */ e.createElement("span", { className: te.dot })));
}
const ys = "_container_85404_1", gs = "_table_85404_9", hs = "_row_85404_31", vs = "_striped_85404_35", ks = "_clickable_85404_43", Ns = "_alignLeft_85404_47", As = "_alignCenter_85404_51", ws = "_alignRight_85404_55", $s = "_emptyCell_85404_59", W = {
  container: ys,
  table: gs,
  row: hs,
  striped: vs,
  clickable: ks,
  alignLeft: Ns,
  alignCenter: As,
  alignRight: ws,
  emptyCell: $s
};
function ul({
  columns: t,
  rows: a,
  striped: n = !0,
  onRowClick: o,
  emptyMessage: r = "데이터가 없습니다"
}) {
  const s = (l) => l === "center" ? W.alignCenter : l === "right" ? W.alignRight : W.alignLeft;
  return /* @__PURE__ */ e.createElement("div", { className: W.container }, /* @__PURE__ */ e.createElement("table", { className: W.table }, /* @__PURE__ */ e.createElement("thead", null, /* @__PURE__ */ e.createElement("tr", null, t.map((l) => /* @__PURE__ */ e.createElement(
    "th",
    {
      key: l.key,
      className: s(l.align),
      style: l.width ? { width: l.width } : void 0
    },
    l.label
  )))), /* @__PURE__ */ e.createElement("tbody", null, a.length === 0 ? /* @__PURE__ */ e.createElement("tr", null, /* @__PURE__ */ e.createElement("td", { className: W.emptyCell, colSpan: t.length }, r)) : a.map((l, d) => {
    const c = [
      W.row,
      n && d % 2 === 1 ? W.striped : "",
      o ? W.clickable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "tr",
      {
        key: d,
        className: c,
        onClick: o ? () => o(l, d) : void 0
      },
      t.map((i) => /* @__PURE__ */ e.createElement("td", { key: i.key, className: s(i.align) }, l[i.key]))
    );
  }))));
}
const xs = "_grid_plbcd_1", Xs = "_cell_plbcd_6", Cs = "_primaryCell_plbcd_16", Ss = "_label_plbcd_21", Fs = "_value_plbcd_26", Bs = "_note_plbcd_32", oe = {
  grid: xs,
  cell: Xs,
  primaryCell: Cs,
  label: Ss,
  value: Fs,
  note: Bs
};
function pl({
  items: t,
  columns: a = 4,
  primaryFirst: n = !1,
  cellBackground: o,
  cellBorderColor: r,
  labelColor: s,
  valueColor: l,
  primaryBackground: d,
  primaryLabelColor: c,
  primaryValueColor: i,
  primaryNoteColor: m
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: oe.grid,
      style: { gridTemplateColumns: `repeat(${a}, 1fr)` }
    },
    t.map((_, u) => {
      const b = n && u === 0, y = [oe.cell, b ? oe.primaryCell : ""].filter(Boolean).join(" "), E = {};
      o !== void 0 && (E.background = o), r !== void 0 && (E.borderColor = r), b && d !== void 0 && (E.background = d, E.borderColor = "transparent");
      const h = {};
      s !== void 0 && (h.color = s), b && c !== void 0 && (h.color = c);
      const w = {};
      l !== void 0 && (w.color = l), b && i !== void 0 && (w.color = i);
      const X = {};
      return b && m !== void 0 && (X.color = m), /* @__PURE__ */ e.createElement("div", { key: `${_.label}-${u}`, className: y, style: E }, /* @__PURE__ */ e.createElement("span", { className: oe.label, style: h }, _.label), /* @__PURE__ */ e.createElement("span", { className: oe.value, style: w }, _.value), _.note && /* @__PURE__ */ e.createElement("span", { className: oe.note, style: X }, _.note));
    })
  );
}
const js = "_button_16ajt_1", Ls = "_disabledSolid_16ajt_19", Is = "_icon_16ajt_26", Ds = "_label_16ajt_32", Ms = "_fullWidth_16ajt_37", Ts = "_sm_16ajt_41", Rs = "_md_16ajt_47", Ps = "_lg_16ajt_53", Os = "_primary_16ajt_59", qs = "_secondary_16ajt_70", Gs = "_outline_16ajt_81", zs = "_ghost_16ajt_93", Ws = "_active_16ajt_104", Ks = "_colorOverride_16ajt_116", Hs = "_gradient_16ajt_126", Vs = "_dashed_16ajt_135", Us = "_pill_16ajt_139", I = {
  button: js,
  disabledSolid: Ls,
  icon: Is,
  label: Ds,
  fullWidth: Ms,
  sm: Ts,
  md: Rs,
  lg: Ps,
  primary: Os,
  secondary: qs,
  outline: Gs,
  ghost: zs,
  active: Ws,
  colorOverride: Ks,
  gradient: Hs,
  dashed: Vs,
  pill: Us
};
function El({
  variant: t = "primary",
  size: a = "md",
  icon: n,
  iconPosition: o = "leading",
  disabled: r = !1,
  disabledVariant: s = "dim",
  onClick: l,
  children: d,
  fullWidth: c = !1,
  type: i = "button",
  active: m = !1,
  color: _,
  background: u,
  borderColor: b,
  hoverColor: y,
  hoverBackground: E,
  gradient: h,
  borderStyle: w = "solid",
  shape: X = "rounded"
}) {
  const T = _ !== void 0 || b !== void 0 || y !== void 0 || E !== void 0, O = [
    I.button,
    I[t],
    I[a],
    c ? I.fullWidth : "",
    r && s === "solid" ? I.disabledSolid : "",
    m ? I.active : "",
    T ? I.colorOverride : "",
    h || u ? I.gradient : "",
    w === "dashed" ? I.dashed : "",
    X === "pill" ? I.pill : ""
  ].filter(Boolean).join(" "), q = {
    ..._ !== void 0 ? { "--ax-btn-color": _ } : {},
    ...b !== void 0 ? { "--ax-btn-border": b } : {},
    ...y !== void 0 ? { "--ax-btn-hover-color": y } : {},
    ...E !== void 0 ? { "--ax-btn-hover-bg": E } : {},
    ...h ? { background: `linear-gradient(135deg, ${h[0]}, ${h[1]})` } : {},
    ...u !== void 0 ? { background: u } : {}
  }, V = n && /* @__PURE__ */ e.createElement("span", { className: I.icon }, n);
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: i,
      className: O,
      style: q,
      disabled: r,
      onClick: l
    },
    o === "leading" && V,
    /* @__PURE__ */ e.createElement("span", { className: I.label }, d),
    o === "trailing" && V
  );
}
const Qs = "_iconButton_1oiog_1", Ys = "_sm_1oiog_18", Js = "_md_1oiog_23", Zs = "_lg_1oiog_28", er = "_plain_1oiog_33", tr = "_outline_1oiog_42", ar = "_circle_1oiog_53", nr = "_bordered_1oiog_62", or = "_tint_1oiog_73", sr = "_active_1oiog_81", rr = "_hoverBgOverride_1oiog_92", cr = "_gradient_1oiog_96", Y = {
  iconButton: Qs,
  sm: Ys,
  md: Js,
  lg: Zs,
  plain: er,
  outline: tr,
  circle: ar,
  bordered: nr,
  tint: or,
  active: sr,
  hoverBgOverride: rr,
  gradient: cr
};
function bl({
  icon: t,
  title: a,
  active: n = !1,
  size: o = "md",
  variant: r = "plain",
  onClick: s,
  onMouseDown: l,
  disabled: d = !1,
  color: c,
  hoverColor: i,
  bordered: m = !1,
  borderColor: _ = "#e2e8f0",
  borderHoverColor: u = "#3b82f6",
  tint: b = !1,
  tintColor: y = "#eef4ff",
  tintHoverColor: E = "#dbeafe",
  hoverBackground: h,
  gradient: w
}) {
  const X = typeof o == "number", T = [
    Y.iconButton,
    X ? "" : Y[o],
    Y[r],
    n ? Y.active : "",
    m ? Y.bordered : "",
    b ? Y.tint : "",
    h !== void 0 ? Y.hoverBgOverride : "",
    w ? Y.gradient : ""
  ].filter(Boolean).join(" "), O = {
    ...X ? { width: o, height: o } : {},
    ...c !== void 0 ? { "--ax-icon-color": c } : {},
    ...i !== void 0 ? { "--ax-icon-hover": i } : {},
    ...m ? { "--ax-icon-border": _, "--ax-icon-border-hover": u } : {},
    ...b ? { "--ax-icon-tint": y, "--ax-icon-tint-hover": E } : {},
    ...h !== void 0 ? { "--ax-icon-hover-bg": h } : {},
    ...w ? { background: `linear-gradient(135deg, ${w[0]}, ${w[1]})` } : {}
  };
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: T,
      style: O,
      onClick: s,
      onMouseDown: l,
      disabled: d,
      title: a,
      "aria-label": a
    },
    t
  );
}
const lr = "_control_1kv40_1", ir = "_option_1kv40_10", dr = "_active_1kv40_28", _r = "_sm_1kv40_37", mr = "_md_1kv40_43", ur = "_dot_1kv40_49", pr = "_count_1kv40_56", Er = "_outline_1kv40_70", br = "_outlineOption_1kv40_75", K = {
  control: lr,
  option: ir,
  active: dr,
  sm: _r,
  md: mr,
  dot: ur,
  count: pr,
  outline: Er,
  outlineOption: br
};
function fl({
  options: t,
  value: a,
  onChange: n,
  size: o = "md",
  variant: r = "filled",
  activeBackground: s,
  activeColor: l,
  activeBorderColor: d
}) {
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: [K.control, K[o], r === "outline" ? K.outline : ""].filter(Boolean).join(" "),
      role: "tablist"
    },
    t.map((c) => {
      const i = c.value === a, m = i ? {
        ...s !== void 0 ? { background: s } : {},
        ...l !== void 0 ? { color: l } : {},
        ...d !== void 0 ? { borderColor: d } : {}
      } : void 0;
      return /* @__PURE__ */ e.createElement(
        "button",
        {
          key: c.value,
          type: "button",
          role: "tab",
          "aria-selected": i,
          className: [K.option, i ? K.active : "", r === "outline" ? K.outlineOption : ""].filter(Boolean).join(" "),
          style: m,
          onClick: () => n(c.value)
        },
        c.dot && /* @__PURE__ */ e.createElement("span", { className: K.dot, style: { backgroundColor: c.dot } }),
        /* @__PURE__ */ e.createElement("span", { className: K.label }, c.label),
        typeof c.count == "number" && /* @__PURE__ */ e.createElement("span", { className: K.count }, c.count)
      );
    })
  );
}
const fr = "_chip_8jgxm_1", yr = "_clickable_8jgxm_14", gr = "_suggested_8jgxm_23", hr = "_readonly_8jgxm_33", vr = "_plusIcon_8jgxm_39", kr = "_label_8jgxm_45", Nr = "_removeButton_8jgxm_50", se = {
  chip: fr,
  clickable: yr,
  default: "_default_8jgxm_18",
  suggested: gr,
  readonly: hr,
  plusIcon: vr,
  label: kr,
  removeButton: Nr
};
function yl({
  label: t,
  variant: a = "default",
  onRemove: n,
  onClick: o,
  background: r,
  textColor: s,
  borderColor: l
}) {
  const d = [se.chip, se[a], o ? se.clickable : ""].filter(Boolean).join(" "), i = r !== void 0 || s !== void 0 || l !== void 0 ? {
    ...r !== void 0 ? { background: r } : {},
    ...s !== void 0 ? { color: s } : {},
    ...l !== void 0 ? { borderColor: l } : {}
  } : {}, m = a !== "readonly" && !!n, _ = /* @__PURE__ */ e.createElement(e.Fragment, null, a === "suggested" && /* @__PURE__ */ e.createElement("span", { className: se.plusIcon, "aria-hidden": "true" }, "+"), /* @__PURE__ */ e.createElement("span", { className: se.label }, t), m && /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: se.removeButton,
      "aria-label": `remove ${t}`,
      onClick: (u) => {
        u.stopPropagation(), n == null || n();
      }
    },
    /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ e.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ e.createElement("path", { d: "M6 6l12 12" }))
  ));
  return o ? /* @__PURE__ */ e.createElement(
    "div",
    {
      role: "button",
      tabIndex: 0,
      className: d,
      style: i,
      onClick: o,
      onKeyDown: (u) => {
        (u.key === "Enter" || u.key === " ") && (u.preventDefault(), o());
      }
    },
    _
  ) : /* @__PURE__ */ e.createElement("span", { className: d, style: i }, _);
}
const Ar = "_wrapper_15dm4_1", wr = "_disabled_15dm4_8", $r = "_track_15dm4_13", xr = "_checked_15dm4_30", Xr = "_thumb_15dm4_34", Cr = "_label_15dm4_50", re = {
  wrapper: Ar,
  disabled: wr,
  track: $r,
  checked: xr,
  thumb: Xr,
  label: Cr
};
function gl({
  checked: t,
  onChange: a,
  labelOn: n,
  labelOff: o,
  disabled: r = !1,
  color: s
}) {
  const l = t ? n : o;
  return /* @__PURE__ */ e.createElement("label", { className: [re.wrapper, r ? re.disabled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": t,
      disabled: r,
      className: [re.track, t ? re.checked : ""].filter(Boolean).join(" "),
      style: t && s !== void 0 ? { background: s } : void 0,
      onClick: () => !r && a(!t)
    },
    /* @__PURE__ */ e.createElement("span", { className: re.thumb })
  ), l && /* @__PURE__ */ e.createElement("span", { className: re.label }, l));
}
const Sr = "_card_1uh3t_1", Fr = "_active_1uh3t_24", Br = "_iconChip_1uh3t_29", jr = "_body_1uh3t_41", Lr = "_label_1uh3t_48", Ir = "_description_1uh3t_54", ce = {
  card: Sr,
  active: Fr,
  iconChip: Br,
  body: jr,
  label: Lr,
  description: Ir
};
function hl(t) {
  const { icon: a, label: n, description: o, active: r = !1, onClick: s } = t;
  return /* @__PURE__ */ e.createElement(
    "button",
    {
      type: "button",
      className: `${ce.card} ${r ? ce.active : ""}`,
      onClick: s,
      "aria-pressed": r
    },
    /* @__PURE__ */ e.createElement("span", { className: ce.iconChip }, a),
    /* @__PURE__ */ e.createElement("span", { className: ce.body }, /* @__PURE__ */ e.createElement("span", { className: ce.label }, n), o && /* @__PURE__ */ e.createElement("span", { className: ce.description }, o))
  );
}
const Dr = "_breadcrumb_zkol9_1", Mr = "_list_zkol9_6", Tr = "_item_zkol9_16", Rr = "_link_zkol9_22", Pr = "_plain_zkol9_43", Or = "_current_zkol9_48", qr = "_separator_zkol9_54", ae = {
  breadcrumb: Dr,
  list: Mr,
  item: Tr,
  link: Rr,
  plain: Pr,
  current: Or,
  separator: qr
};
function vl(t) {
  const { items: a, separator: n = "/", textColor: o, hoverColor: r, currentColor: s } = t, l = {
    ...o !== void 0 ? { "--ax-bc-text": o } : {},
    ...r !== void 0 ? { "--ax-bc-hover": r } : {},
    ...s !== void 0 ? { "--ax-bc-current": s } : {}
  };
  return /* @__PURE__ */ e.createElement("nav", { className: ae.breadcrumb, "aria-label": "breadcrumb", style: l }, /* @__PURE__ */ e.createElement("ol", { className: ae.list }, a.map((d, c) => {
    const i = c === a.length - 1;
    return /* @__PURE__ */ e.createElement("li", { key: c, className: ae.item }, i ? /* @__PURE__ */ e.createElement("span", { className: ae.current, "aria-current": "page" }, d.label) : d.onClick ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: ae.link,
        onClick: d.onClick
      },
      d.label
    ) : /* @__PURE__ */ e.createElement("span", { className: ae.plain }, d.label), !i && /* @__PURE__ */ e.createElement("span", { className: ae.separator, "aria-hidden": "true" }, n));
  })));
}
const Gr = "_treeItem_1ouqz_1", zr = "_active_1ouqz_18", Wr = "_chevron_1ouqz_28", Kr = "_chevronExpanded_1ouqz_48", Hr = "_chevronSpacer_1ouqz_52", Vr = "_icon_1ouqz_57", Ur = "_label_1ouqz_69", Qr = "_count_1ouqz_76", Yr = "_dark_1ouqz_86", H = {
  treeItem: Gr,
  active: zr,
  chevron: Wr,
  chevronExpanded: Kr,
  chevronSpacer: Hr,
  icon: Vr,
  label: Ur,
  count: Qr,
  dark: Yr
};
function kl(t) {
  const {
    icon: a,
    label: n,
    count: o,
    indent: r = 0,
    active: s = !1,
    expandable: l = !1,
    expanded: d = !1,
    theme: c = "light",
    onToggleExpand: i,
    onClick: m
  } = t, _ = (b) => {
    b.stopPropagation(), i == null || i();
  }, u = c === "dark" ? H.dark : "";
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      className: `${H.treeItem} ${u} ${s ? H.active : ""}`,
      style: { paddingLeft: 12 + r * 16 },
      onClick: m,
      role: "treeitem",
      "aria-selected": s,
      "aria-expanded": l ? d : void 0
    },
    l ? /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: `${H.chevron} ${d ? H.chevronExpanded : ""}`,
        onClick: _,
        "aria-label": d ? "Collapse" : "Expand"
      },
      /* @__PURE__ */ e.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" }, /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M3 1.5L7 5L3 8.5",
          stroke: "currentColor",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ))
    ) : /* @__PURE__ */ e.createElement("span", { className: H.chevronSpacer }),
    a && /* @__PURE__ */ e.createElement("span", { className: H.icon }, a),
    /* @__PURE__ */ e.createElement("span", { className: H.label }, n),
    typeof o == "number" && /* @__PURE__ */ e.createElement("span", { className: H.count }, o)
  );
}
const Jr = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function He(t) {
  return Array.from(t.querySelectorAll(Jr)).filter((a) => a.getClientRects().length > 0 && getComputedStyle(a).visibility !== "hidden");
}
let Ve = 0, Ue = "";
function rt(t) {
  const a = J(null), n = J(t);
  n.current = t;
  const o = J(void 0);
  return o.current === void 0 && (o.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var d;
    const s = a.current, l = (d = o.current) != null ? d : null;
    return s && !s.contains(document.activeElement) && (He(s)[0] || s).focus(), Ve++ === 0 && (Ue = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ve === 0 && (document.body.style.overflow = Ue), l && l.isConnected && typeof l.focus == "function" && l.focus();
    };
  }, []), { dialogRef: a, onKeyDown: (s) => {
    const l = a.current;
    if (!l) return;
    if (s.key === "Escape") {
      s.stopPropagation(), n.current();
      return;
    }
    if (s.key !== "Tab" || !l.contains(s.target)) return;
    const d = He(l);
    if (d.length === 0) {
      s.preventDefault(), l.focus();
      return;
    }
    const c = d[0], i = d[d.length - 1], m = document.activeElement;
    s.shiftKey && (m === c || m === l) ? (s.preventDefault(), i.focus()) : !s.shiftKey && m === i && (s.preventDefault(), c.focus());
  } };
}
const Zr = "_backdrop_gstyy_1", ec = "_panel_gstyy_9", tc = "_right_gstyy_21", ac = "_left_gstyy_27", nc = "_header_gstyy_51", oc = "_icon_gstyy_59", sc = "_titleGroup_gstyy_66", rc = "_kicker_gstyy_71", cc = "_title_gstyy_66", lc = "_subtitle_gstyy_87", ic = "_closeButton_gstyy_93", dc = "_body_gstyy_115", _c = "_footer_gstyy_123", j = {
  backdrop: Zr,
  panel: ec,
  right: tc,
  left: ac,
  header: nc,
  icon: oc,
  titleGroup: sc,
  kicker: rc,
  title: cc,
  subtitle: lc,
  closeButton: ic,
  body: dc,
  footer: _c
};
function Nl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(mc, { ...t }) : null;
}
function mc({
  onClose: t,
  icon: a,
  kicker: n,
  title: o,
  titleSize: r,
  titleWeight: s,
  subtitle: l,
  footer: d,
  children: c,
  side: i = "right",
  headerBackground: m,
  topOffset: _
}) {
  const { dialogRef: u, onKeyDown: b } = rt(t), y = Ye("ax-drawer-t"), E = [j.panel, i === "left" ? j.left : j.right].filter(Boolean).join(" "), h = {
    ...r !== void 0 ? { fontSize: r } : {},
    ...s !== void 0 ? { fontWeight: s } : {}
  }, w = _ !== void 0 ? { top: _, height: `calc(100vh - ${_}px)` } : void 0;
  return /* @__PURE__ */ e.createElement("div", { className: j.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: u,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": y,
      className: E,
      style: w,
      onClick: (X) => X.stopPropagation(),
      onKeyDown: b
    },
    /* @__PURE__ */ e.createElement("div", { className: j.header, style: m !== void 0 ? { background: m } : void 0 }, a && /* @__PURE__ */ e.createElement("span", { className: j.icon }, a), /* @__PURE__ */ e.createElement("div", { className: j.titleGroup }, n && /* @__PURE__ */ e.createElement("p", { className: j.kicker }, n), /* @__PURE__ */ e.createElement("h2", { className: j.title, id: y, style: h }, o), l && /* @__PURE__ */ e.createElement("p", { className: j.subtitle }, l)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: j.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: j.body }, c),
    d && /* @__PURE__ */ e.createElement("div", { className: j.footer }, d)
  ));
}
const uc = "_backdrop_6kso7_1", pc = "_menu_6kso7_8", Ec = "_alignRight_6kso7_24", bc = "_alignLeft_6kso7_28", fc = "_item_6kso7_32", yc = "_itemIcon_6kso7_50", gc = "_itemText_6kso7_59", hc = "_itemLabel_6kso7_66", vc = "_itemDescription_6kso7_72", kc = "_danger_6kso7_77", R = {
  backdrop: uc,
  menu: pc,
  alignRight: Ec,
  alignLeft: bc,
  item: fc,
  itemIcon: yc,
  itemText: gc,
  itemLabel: hc,
  itemDescription: vc,
  danger: kc
};
function Al(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Nc, { ...t }) : null;
}
function Nc({
  onClose: t,
  items: a,
  anchor: n = "right"
}) {
  const o = J(null), r = J(void 0);
  r.current === void 0 && (r.current = typeof document == "undefined" ? null : document.activeElement), Z(() => {
    var i, m, _;
    const c = (i = r.current) != null ? i : null;
    return (_ = (m = o.current) == null ? void 0 : m.querySelector("button")) == null || _.focus(), () => {
      c && c.isConnected && typeof c.focus == "function" && c.focus();
    };
  }, []);
  const s = [R.menu, n === "left" ? R.alignLeft : R.alignRight].filter(Boolean).join(" "), l = (c) => {
    c.onClick(), t();
  }, d = (c) => {
    var u, b;
    const i = Array.from((b = (u = o.current) == null ? void 0 : u.querySelectorAll("button")) != null ? b : []), m = i.indexOf(document.activeElement), _ = (y) => {
      var E;
      c.preventDefault(), (E = i[(y + i.length) % i.length]) == null || E.focus();
    };
    c.key === "ArrowDown" ? _(m + 1) : c.key === "ArrowUp" ? _(m <= 0 ? i.length - 1 : m - 1) : c.key === "Home" ? _(0) : c.key === "End" ? _(i.length - 1) : (c.key === "Escape" || c.key === "Tab") && (c.key === "Escape" && c.preventDefault(), t());
  };
  return /* @__PURE__ */ e.createElement(ct, null, /* @__PURE__ */ e.createElement("div", { className: R.backdrop, onClick: t }), /* @__PURE__ */ e.createElement("div", { ref: o, role: "menu", className: s, onClick: (c) => c.stopPropagation(), onKeyDown: d }, a.map((c, i) => {
    const m = [R.item, c.danger ? R.danger : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ e.createElement(
      "button",
      {
        key: i,
        type: "button",
        role: "menuitem",
        className: m,
        onClick: () => l(c)
      },
      c.icon && /* @__PURE__ */ e.createElement("span", { className: R.itemIcon }, c.icon),
      /* @__PURE__ */ e.createElement("span", { className: R.itemText }, /* @__PURE__ */ e.createElement("span", { className: R.itemLabel }, c.label), c.description && /* @__PURE__ */ e.createElement("span", { className: R.itemDescription }, c.description))
    );
  })));
}
const Ac = "_backdrop_3pc9i_1", wc = "_card_3pc9i_12", $c = "_header_3pc9i_23", xc = "_icon_3pc9i_31", Xc = "_titleGroup_3pc9i_38", Cc = "_title_3pc9i_38", Sc = "_subtitle_3pc9i_50", Fc = "_closeButton_3pc9i_56", Bc = "_body_3pc9i_78", jc = "_footer_3pc9i_85", P = {
  backdrop: Ac,
  card: wc,
  header: $c,
  icon: xc,
  titleGroup: Xc,
  title: Cc,
  subtitle: Sc,
  closeButton: Fc,
  body: Bc,
  footer: jc
};
function wl(t) {
  return t.open ? /* @__PURE__ */ e.createElement(Lc, { ...t }) : null;
}
function Lc({
  onClose: t,
  icon: a,
  title: n,
  subtitle: o,
  footer: r,
  width: s = 480,
  children: l
}) {
  const { dialogRef: d, onKeyDown: c } = rt(t), i = Ye("ax-modal-t"), m = typeof s == "number" ? `${s}px` : s;
  return /* @__PURE__ */ e.createElement("div", { className: P.backdrop, onClick: t }, /* @__PURE__ */ e.createElement(
    "div",
    {
      ref: d,
      tabIndex: -1,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": i,
      className: P.card,
      style: { width: m },
      onClick: (_) => _.stopPropagation(),
      onKeyDown: c
    },
    /* @__PURE__ */ e.createElement("div", { className: P.header }, a && /* @__PURE__ */ e.createElement("span", { className: P.icon }, a), /* @__PURE__ */ e.createElement("div", { className: P.titleGroup }, /* @__PURE__ */ e.createElement("h2", { className: P.title, id: i }, n), o && /* @__PURE__ */ e.createElement("p", { className: P.subtitle }, o)), /* @__PURE__ */ e.createElement(
      "button",
      {
        type: "button",
        className: P.closeButton,
        onClick: t,
        "aria-label": "닫기"
      },
      "×"
    )),
    /* @__PURE__ */ e.createElement("div", { className: P.body }, l),
    r && /* @__PURE__ */ e.createElement("div", { className: P.footer }, r)
  ));
}
export {
  we as ACTIVE_AFFILIATION_KEY_PREFIX,
  gt as ACTIVE_COM_HEADER,
  ht as ACTIVE_DEPT_HEADER,
  hl as AXActionCard,
  Yc as AXAiIconBadge,
  cl as AXAiSuggestionBanner,
  st as AXAvatar,
  Jc as AXAvatarStack,
  Zc as AXBadge,
  vl as AXBreadcrumb,
  El as AXButton,
  Vc as AXCardPanel,
  el as AXCommentRow,
  Kc as AXCommentThread,
  ul as AXDataTable,
  Uc as AXDivider,
  Nl as AXDrawer,
  Al as AXDropdownMenu,
  Xl as AXERP_EMPTY_SET_TEXT,
  ll as AXEmptyState,
  zl as AXErpAccordion,
  Wl as AXErpActionMenu,
  Kl as AXErpAiAnswerPanel,
  Hl as AXErpBanner,
  Vl as AXErpBarChart,
  Ul as AXErpButton,
  Ql as AXErpCalculatorModal,
  Yl as AXErpCalculatorProvider,
  Jl as AXErpCalendar,
  Zl as AXErpCard,
  ei as AXErpCheckGroup,
  ti as AXErpCheckList,
  ai as AXErpCheckbox,
  ni as AXErpCodeBadge,
  oi as AXErpCodePicker,
  si as AXErpContextHelp,
  ri as AXErpContextMenu,
  ci as AXErpCriticalAlert,
  li as AXErpCsvButton,
  ii as AXErpCsvPick,
  di as AXErpDataTable,
  _i as AXErpDatePicker,
  mi as AXErpDateRange,
  ui as AXErpDonutChart,
  pi as AXErpDropArea,
  Ei as AXErpEmptySet,
  bi as AXErpError,
  fi as AXErpField,
  yi as AXErpFileButton,
  gi as AXErpFileDrop,
  hi as AXErpFilterBand,
  vi as AXErpFormModal,
  ki as AXErpFormRow,
  Ni as AXErpFormSection,
  Ai as AXErpGantt,
  wi as AXErpGisuField,
  $i as AXErpGlyph,
  xi as AXErpGrid,
  Xi as AXErpGridStatus,
  Ci as AXErpHint,
  Si as AXErpIcon,
  Fi as AXErpIconButton,
  Bi as AXErpImageThumbs,
  ji as AXErpKanban,
  Li as AXErpKpiTile,
  Ii as AXErpKpiTileGroup,
  Di as AXErpLinkButton,
  Mi as AXErpLoadMore,
  Ti as AXErpMainScreen,
  Ri as AXErpMenuAreaHead,
  Pi as AXErpMenuGroup,
  Oi as AXErpMiniCalendar,
  qi as AXErpModal,
  Gi as AXErpMoneyInput,
  zi as AXErpMsg,
  Wi as AXErpMultiSelect,
  Ki as AXErpNote,
  Hi as AXErpOverviewGrid,
  Vi as AXErpPage,
  Ui as AXErpPageBody,
  Qi as AXErpPageFrame,
  Yi as AXErpPagination,
  Ji as AXErpPill,
  Zi as AXErpPopover,
  ed as AXErpProgressBar,
  td as AXErpProposalBanner,
  ad as AXErpProposalCards,
  nd as AXErpProposalList,
  od as AXErpProposalModal,
  sd as AXErpQtyInput,
  rd as AXErpQuickMenu,
  cd as AXErpRadioGroup,
  ld as AXErpReadonly,
  id as AXErpReadout,
  dd as AXErpSaveBar,
  _d as AXErpSearchBar,
  md as AXErpSelect,
  ud as AXErpShortcutHelp,
  pd as AXErpSideBar,
  Ed as AXErpSidePanel,
  bd as AXErpSidePanelGroup,
  fd as AXErpSkipLink,
  yd as AXErpSortAnnounce,
  gd as AXErpSortTh,
  hd as AXErpSpinner,
  vd as AXErpStartGuide,
  kd as AXErpStatCard,
  Nd as AXErpStateBadge,
  Ad as AXErpStepIndicator,
  wd as AXErpSummaryCard,
  $d as AXErpSummaryList,
  xd as AXErpSwitch,
  Xd as AXErpTabs,
  Cd as AXErpTag,
  Sd as AXErpTagList,
  Fd as AXErpTextInput,
  Bd as AXErpTitleBar,
  jd as AXErpToastProvider,
  Ld as AXErpToggle,
  Id as AXErpTooltip,
  Dd as AXErpTreeCell,
  Md as AXErpVerify,
  Td as AXErpVirtualBody,
  Rd as AXErpVisuallyHidden,
  Pd as AXErpWeekStepper,
  Od as AXErpWeekStrip,
  il as AXExpandableSummary,
  tl as AXFileChip,
  un as AXFileTypeIcon,
  bl as AXIconButton,
  pl as AXKeyValueGrid,
  al as AXKeyValueRow,
  nl as AXListRow,
  wl as AXModal,
  Qc as AXPanelHeader,
  ol as AXPersonRow,
  dl as AXProgressBar,
  sl as AXRankingRow,
  qd as AXSearchInput,
  fl as AXSegmentedControl,
  rl as AXStatusBadge,
  _l as AXStepProgress,
  yl as AXTagChip,
  gl as AXToggleSwitch,
  kl as AXTreeItem,
  ml as AXTypingDots,
  Gd as AX_ERP_CALENDAR_KO,
  zd as AX_ERP_DIRTY_MESSAGE,
  Wd as AX_ERP_SHORTCUTS,
  zc as CurrencyUnit,
  Le as GW_ORIGIN,
  Kd as JAPANESE_ERAS,
  Hd as OBTPortal,
  Vd as OBTResizeContainer,
  Ud as OBTResizeSensor,
  ge as REFRESH_KEY,
  Ce as SESSION_EXPIRED_EVENT,
  je as TOKEN_KEY,
  vt as activeAffiliationHeaders,
  Cl as amDigits,
  Sl as amNumber,
  le as authorizedFetch,
  Qd as axErpAddDays,
  Yd as axErpAriaSort,
  Jd as axErpAutoLineAm,
  Zd as axErpCalendarLocale,
  e_ as axErpChangedKeys,
  t_ as axErpCodeDisplay,
  a_ as axErpCodeLabel,
  n_ as axErpCodeNameOf,
  o_ as axErpCompareSortValue,
  s_ as axErpDownload,
  Fl as axErpEmptySetText,
  r_ as axErpFileName,
  c_ as axErpGisuLabel,
  l_ as axErpHttpMessage,
  i_ as axErpIsHelpKey,
  d_ as axErpKeepInPlace,
  __ as axErpKpiColumns,
  m_ as axErpMenuItem,
  u_ as axErpMenuSection,
  p_ as axErpMergeBase,
  E_ as axErpNextSort,
  b_ as axErpPageCount,
  f_ as axErpPageItems,
  y_ as axErpParsePage,
  g_ as axErpQtyDecimals,
  h_ as axErpQtyFormat,
  v_ as axErpQtyOutOfRange,
  k_ as axErpQtyParse,
  N_ as axErpQtyRound,
  A_ as axErpQtyStep,
  w_ as axErpQtyTimesUnit,
  $_ as axErpRangeValid,
  x_ as axErpRovingMove,
  X_ as axErpRowActivate,
  C_ as axErpSameValues,
  S_ as axErpSaveBlob,
  F_ as axErpSaveCsv,
  B_ as axErpSortForest,
  j_ as axErpSortMessage,
  L_ as axErpSortValue,
  I_ as axErpSubmitShortcutLabel,
  D_ as axErpTableToCsv,
  M_ as axErpTotalLabel,
  T_ as axErpWeekOf,
  ut as clearTokens,
  Tc as colors,
  Rc as configureAuth,
  Wc as configureComments,
  R_ as csvFormulaGuard,
  P_ as csvNumber,
  dt as currencyDigits,
  Bl as currencyText,
  Ie as currentUsername,
  $e as decodeClaims,
  Gc as ensureBaseCurrency,
  O_ as eraOf,
  q_ as eraShortDate,
  G_ as eraYearLabel,
  jl as fmtAm,
  z_ as fmtDt,
  Ll as fmtDtMin,
  it as fmtMoney,
  Il as fmtMoneyText,
  Dl as fmtNum,
  Ml as fmtNumBlank,
  Tl as fmtNumDash,
  Rl as fmtYen,
  De as getActiveAffiliation,
  Pl as getBaseCurrency,
  yt as getFreshToken,
  et as getStoredToken,
  _t as isExpired,
  Ze as isRefreshExpired,
  wt as isReply,
  W_ as measureMoneyMetrics,
  K_ as moneyColWidth,
  H_ as moneyColWidthForDigits,
  lt as moneyUnit,
  fe as notifySessionExpired,
  qc as onActiveAffiliationChange,
  Pc as onSessionExpired,
  kt as pickCurrencyCode,
  at as refreshTokens,
  mt as saveTokens,
  Ol as setAXErpEmptySetText,
  Oc as setActiveAffiliation,
  Qe as setBaseCurrency,
  Et as startRefreshExpiryWatch,
  tt as stopRefreshExpiryWatch,
  V_ as textColWidth,
  U_ as textWidth,
  Nt as toCurrency,
  ql as toHalfWidth,
  Q_ as todayLocal,
  Y_ as useAXErpBusy,
  J_ as useAXErpCalculator,
  Z_ as useAXErpConfirm,
  em as useAXErpDirtyGuard,
  tm as useAXErpEditor,
  am as useAXErpFilePicker,
  nm as useAXErpNotice,
  om as useAXErpPaged,
  sm as useAXErpQuery,
  rm as useAXErpQuickMenu,
  cm as useAXErpRovingGrid,
  lm as useAXErpRunLock,
  im as useAXErpShortcutHelp,
  dm as useAXErpSubmitShortcut,
  _m as useAXErpToast,
  mm as useAXErpTree,
  Ye as useAXErpUid,
  Hc as useCommentCounts,
  Ft as useComments,
  At as useCurrency
};
